import { ReactComponent as MoreIcon } from "components/icons/moreIcon.svg";
import "./MoreTagsButton.scss";

export const MoreTagsButton = (props: {
  onClick: () => void;
}): JSX.Element => {
  return (
    <button className="more moreTags" onClick={props.onClick}>
      <MoreIcon />
    </button>
  );
};
